export const totalSeconds = 86399; // 24h * 60min * 60s